export default __webpack_public_path__ + "static/media/search-icon.654836c1.svg";